// extracted by mini-css-extract-plugin
export default {"bgOrange":"footer_bgOrange__QeUsf","bgBlack":"footer_bgBlack__7eZWk","bgDarkBlue":"footer_bgDarkBlue__BErMk"};